import type { AnalyticsEventContext } from './types';

/**
 * Mapping of context keys to their Amplitude group equivalents.
 * Any context key not in this mapping will be ignored and tracked as a normal property.
 */
const AMPLITUDE_GROUPS: {
    [contextKey: string]: string;
} = {
    organization: 'orgId',
    site: 'site',
    space: 'spaceId',
    page: 'page',
    collection: 'collection',
    changeRequest: 'changeRequest',
};

/**
 * Amplitude has historic data from pre-2021 and thus the groups need to be retro-compatible.
 * In order to keep the codebase clean we do this just before sending to Amplitude.
 *
 * We also only track a few key contexts as groups in Amplitude.
 */
export function transformAmplitudeGroups(context: AnalyticsEventContext): {
    properties: {
        [propName: string]: string;
    };
    groups: {
        [groupType: string]: string | string[];
    };
} {
    const properties: Record<string, string> = {};
    const groups: Record<string, string> = {};

    Object.entries(context).forEach(([key, value]) => {
        if (AMPLITUDE_GROUPS[key]) {
            groups[AMPLITUDE_GROUPS[key]] = value;
        } else {
            properties[key] = value;
        }
    });

    return { properties, groups };
}
